  // src/api/TICKET/ticket.js

const API_URL = process.env.REACT_APP_API_URL;

//Get all tickets
export async function getAllTickets(_page= 1, _limit= 10, _search= "") {
  // TODO: implement
}

// ─── Shared filter/sort URL builder ───────────────────────────────────────────────
function buildTicketParams(page, limit, search, filters, tri, ordre) {
  const {
    statuses       = [],
    userId         = null,
    userIds        = [],
    groupId        = null,
    groupIds       = [],
    clientId       = null,
    description    = "",
    approuveur     = null,
    facturation    = null,
    facturationIds = [],
    priorite       = null,
    type           = null,
    dateDebut      = null,
    dateFin        = null,
    dateCloture    = null,
  } = filters;

  const conditions = [];
  if (search?.trim())      conditions.push(`titre:'${search.trim().replace(/'/g, "''")}'`);
  if (statuses.length > 0) {
    const parts = statuses.map(s => `status:'${s}'`);
    conditions.push(parts.length > 1 ? `(${parts.join(" OR ")})` : parts[0]);
  }
  const userIdList = [
    ...new Set([
      ...(Array.isArray(userIds) ? userIds : []),
      ...(userId ? [userId] : []),
    ].filter(Boolean)),
  ];
  const groupIdList = [
    ...new Set([
      ...(Array.isArray(groupIds) ? groupIds : []),
      ...(groupId ? [groupId] : []),
    ].filter(Boolean)),
  ];
  if (userIdList.length > 0 || groupIdList.length > 0) {
    const parts = [
      ...userIdList.map(id => `user_id:'${id}'`),
      ...groupIdList.map(id => `group_id:'${id}'`),
    ];
    conditions.push(parts.length > 1 ? `(${parts.join(" OR ")})` : parts[0]);
  }
  if (clientId)            conditions.push(`client:'${clientId}'`);
  if (description?.trim()) conditions.push(`description:'${description.trim().replace(/'/g, "''")}'`);
  if (approuveur)          conditions.push(`approuveur:'${approuveur}'`);
  const facturationIdList = [...new Set([
    ...(Array.isArray(facturationIds) ? facturationIds : []),
    ...(facturation ? [facturation] : []),
  ].filter(Boolean))];
  if (facturationIdList.length > 0) {
    const parts = facturationIdList.map(id => `facturation:'${id}'`);
    conditions.push(parts.length > 1 ? `(${parts.join(" OR ")})` : parts[0]);
  }
  if (priorite)            conditions.push(`priorite:'${priorite}'`);
  if (type)                conditions.push(`type:'${type}'`);
  if (dateDebut?.val)      conditions.push(`date_debut:${dateDebut.op}'${dateDebut.val}'`);
  if (dateFin?.val)        conditions.push(`date_fin:${dateFin.op}'${dateFin.val}'`);
  if (dateCloture?.val)    conditions.push(`date_cloture:${dateCloture.op}'${dateCloture.val}'`);

  const params = new URLSearchParams({ page, limite: limit });
  if (conditions.length > 0) params.set("requete", conditions.join(" AND "));
  if (tri) { params.set("tri", tri); params.set("ordre", ordre); }
  return params;
}

// GET active tickets (default: open + in_progress)
export async function getTickets(page = 1, limit = 10, search = "", filters = {}, tri = "date_debut", ordre = "DESC") {
  const effectiveFilters = { statuses: ["open", "in_progress"], ...filters };
  const params = buildTicketParams(page, limit, search, effectiveFilters, tri, ordre);
  const response = await fetch(`${API_URL}/ticket/?${params.toString()}`, {
    method: "GET", credentials: "include", headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Non authentifié");
  return response.json();
}

// GET inactive tickets (default: closed + approved)
export async function getInactiveTickets(page = 1, limit = 10, search = "", filters = {}, tri = "date_debut", ordre = "DESC") {
  const effectiveFilters = { statuses: ["closed", "approved"], ...filters };
  const params = buildTicketParams(page, limit, search, effectiveFilters, tri, ordre);
  const response = await fetch(`${API_URL}/ticket/?${params.toString()}`, {
    method: "GET", credentials: "include", headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Non authentifié");
  return response.json();
}
  //GET ticket by ID
  export async function getTicketById(id) {
    const response = await fetch(`${API_URL}/ticket/${id}`, {
        method: "GET",
        credentials: "include",
      });
      
      if (!response.ok) {
        throw new Error("Non authentifié");
      }

      return response.json();
    }

  //POST create new ticket
  // export async function postTicket(ticketData) {
  //   console.log("creating ticket")
  //   const response = await fetch(`http://127.0.0.1:8000/ticket/`, {
  //     method: "POST",
  //     credentials: "include",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(ticketData),
  //   });

  //   if (!response.ok) {
  //     throw new Error("Erreur lors de la création du ticket");
  //   }

  //   return response.json();
  // }

  export async function postTicket(ticketData) {
    const response = await fetch(`${API_URL}/ticket/`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(ticketData),
    });

    if (!response.ok) {
      let errorMessage = `Erreur lors de la création du ticket (${response.status})`;
      
      try {
        const errorData = await response.json();
        
        // Extraire le message d'erreur du serveur
        if (errorData.message) {
          errorMessage = errorData.message;
        } else if (errorData.error) {
          errorMessage = errorData.error;
        } else if (errorData.errors) {
          // Si c'est un objet d'erreurs de validation
          errorMessage = Object.values(errorData.errors).flat().join(', ');
        }
      } catch (e) {
        try {
          const errorText = await response.text();
          errorMessage = errorText || errorMessage;
        } catch (textError) {
        }
      }
      
      throw new Error(errorMessage);
    }

    return response.json();
  }

  export async function assignTicketUsers(id, userIds) {
  const response = await fetch(`${API_URL}/ticket/${id}/utilisateurs`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ticket: { utilisateurs: userIds }
    }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Erreur ${response.status}`);
  }
  return response.json();
}

export async function removeTicketUsers(id, userIds) {
  const response = await fetch(`${API_URL}/ticket/${id}/utilisateurs`, {
    method: "DELETE",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ticket: { utilisateurs: userIds }
    }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Erreur ${response.status}`);
  }
  return response.json();
}

  //DELETE ticket by ID
  export async function deleteTicket(id) {
    const response = await fetch(`${API_URL}/ticket/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Erreur lors de la suppression du ticket");
    }

    return response.status === 204 ? null : response.json();
  }

  //PUT update ticket by ID
 export async function updateTicket(id, ticketData) {
  const body = JSON.stringify({ ticket: ticketData });
  
  const response = await fetch(`${API_URL}/ticket/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Erreur ${response.status}`);
  }

  return response.json();
}
  //PUT reopen ticket by ID
  export async function reopenTicket(id) {
    const response = await fetch(`${API_URL}/ticket/${id}/reouvrir`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Erreur lors de la réouverture du ticket");
    }

    return response.json();
  }

  //PUT close ticket by ID
  export async function closeTicket(id, facturationModeId) {
    const response = await fetch(`${API_URL}/ticket/${id}/fermer`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ticket: {
          methode_facturation: facturationModeId
        }
      }),
    });

   if (!response.ok) {
    let errorMsg = `Erreur lors de la fermeture du ticket (${response.status})`;
    try {
      const errorData = await response.json();
      if (errorData.message) errorMsg = errorData.message;
    } catch {}
    throw new Error(errorMsg);
  }

    return response.json();
  }

  // GET tickets awaiting approval
  export async function getTicketsAwaitingApproval(page = 1, limit = 10, search = "", filters = {}, tri = "date_debut", ordre = "DESC") {
    const effectiveFilters = { ...filters, statuses: ["closed"] };
    const params = buildTicketParams(page, limit, search, effectiveFilters, tri, ordre);
    const url = `${API_URL}/ticket/?${params.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Non authentifié");
    }

    return response.json();
  }

  // PUT approve tickets by IDs
  export async function approveTickets(ticketIds) {
    const response = await fetch(`${API_URL}/ticket/approuver`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
      approuver: {
        tickets: ticketIds
      }
    }),
    });

    if (!response.ok) {
      let errorMsg = `Erreur lors de l'approbation des tickets (${response.status})`;
      try {
        const errorData = await response.json();
        if (errorData.message) errorMsg = errorData.message;
      } catch {}
      throw new Error(errorMsg);
    }

    return response.json();
  }

  export async function assignTicketGroupes(id, groupeIds) {
  const response = await fetch(`${API_URL}/ticket/${id}/groupes`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ticket: { groupes: groupeIds }
    }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Erreur ${response.status}`);
  }
  return response.json();
}

export async function removeTicketGroupes(id, groupeIds) {
  const response = await fetch(`${API_URL}/ticket/${id}/groupes`, {
    method: "DELETE",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ticket: { groupes: groupeIds }
    }),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Erreur ${response.status}`);
  }
  return response.json();
}